export default __webpack_public_path__ + "maps-examples-source-custom-raster-thumbnail-480-704db88c21cca8d4bd6eee2b916d05e6.webp";